<template>
  <div>

    <Head title="Create Voucher" />
    <div class="flex items-center justify-between mb-6">
      <h1 class="mb-8 text-3xl font-bold">
        <Link class="text-orange-600 hover:text-orange-500" href="/vouchers">Vouchers</Link>
      </h1>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <div>
        <form @submit.prevent="store">
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 20px;">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="w-6 h-6 pb-1" style="display: inline !important;">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M21 11.25v8.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 109.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1114.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z" />
              </svg>
              Create Voucher
            </h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <div v-if="stepOne">
                <div class="pb-2 pr-6 pl-4 mb-3 w-full lg:w-full">
                  <Checkbox label="Online & Retail Customer" :active="active" @input="isOnlineCustomer = $event" />
                </div>
                <div v-if="!isOnlineCustomer" class="flex flex-wrap -mb-8 -mr-6 pt-2 pl-2 pr-8 pb-8">
                  <p class="pb-1">Select Customer:</p>
                  <multiselect id="customer" v-model="form.customer" placeholder="Search Customers" :options="customers"
                    :clear-on-select="false" :preserve-search="true" :searchable="true" class="mt-1 w-1/2"
                    :close-on-select="true" :create-option="true" :error="$props.errors.customer"
                    :style="$props.errors.customer ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                    @select="onSelect" />
                  <p v-if="$props.errors" class="text-red-700 pt-2"><small>{{ $props.errors.customer }}</small>
                  </p>
                </div>
                <div v-if="isOnlineCustomer" class="flex flex-wrap -mb-8 -mr-6 pt-2 pl-2 pr-8 pb-8">
                  <p class="pb-1">Select Customer:</p>
                  <multiselect id="customer" v-model="form.online_customer" placeholder="Search Customers"
                    :options="onlineCustomers" :clear-on-select="false" :preserve-search="true" :searchable="true"
                    class="mt-1 w-1/2" :close-on-select="true" :create-option="true"
                    :error="$props.errors.online_customer"
                    :style="$props.errors.online_customer ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                    @select="onSelect" />
                  <p v-if="$props.errors" class="text-red-700 pt-2"><small>{{ $props.errors.onlineCustomers
                      }}</small></p>
                </div>
                <div v-if="!isOnlineCustomer" class="flex flex-wrap -mb-8 -mr-6 pt-2 pl-2 pr-8 pb-8 pt-4">
                  <p class="pb-1">Select Reason:</p>
                  <multiselect id="voucher_reason" v-model="form.voucher_reason" placeholder="Search Reasons"
                    :options="voucherReasons" :clear-on-select="false" :preserve-search="true" :searchable="true"
                    class="mt-1 w-1/2" :create-option="true" :error="$props.errors.voucher_reason"
                    :style="$props.errors.voucher_reason ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                    @select="onSelect" />
                  <p v-if="$props.errors" class="text-red-700 pt-2"><small>{{ $props.errors.voucher_reason
                      }}</small></p>
                </div>
                <div v-if="isOnlineCustomer" class="flex flex-wrap -mb-8 -mr-6 pt-2 pl-2 pr-8 pb-8 pt-4">
                  <p class="pb-1">Select Reason:</p>
                  <multiselect id="voucher_reason" v-model="form.voucher_reason" placeholder="Search Reasons"
                    :options="onlineVoucherReasons" :clear-on-select="false" :preserve-search="true" :searchable="true"
                    class="mt-1 w-1/2" :create-option="true" :error="$props.errors.voucher_reason"
                    :style="$props.errors.voucher_reason ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                    @select="onSelect" />
                  <p v-if="$props.errors" class="text-red-700 pt-2"><small>{{ $props.errors.voucher_reason
                      }}</small></p>
                </div>
                <div class="lex flex-wrap -mb-8 -mr-6 pt-3 pl-2 pr-2 pb-2">
                  <p class="pb-1">Description:</p>
                  <text-input v-model="form.description" :error="$props.errors.description"
                    class="pb-8 pr-6 w-1/2 lg:w-full" />
                </div>
                <div class="flex flex-wrap -mb-8 -mr-6 pt-2 pl-2 pr-2 pb-2">
                  <text-input v-model="form.value" :error="$props.errors.value" class="pb-8 pr-6 w-1/3 lg:w-1/3"
                    label="Value" />
                  <select-input v-model="form.category" :error="$props.errors.category" class="pb-8 pr-6 w-1/3 lg:w-1/3"
                    label="Category">
                    <option :value="null">-Select-</option>
                    <option value="0">Non Transport</option>
                    <option value="1">Transport</option>
                  </select-input>
                  <select-input v-model="form.type" :error="$props.errors.type" class="pb-8 pr-6 w-1/3 lg:w-1/3"
                    label="Voucher Type">
                    <option :value="null">-Select-</option>
                    <option v-for="typ in types" :key="typ">{{ typ }}</option>
                  </select-input>
                </div>
              </div>
            </div>
          </div>
          <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
            <loading-button :loading="form.processing" class="btn-orange" type="submit">Create</loading-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import TextInput from '@/Shared/TextInput'
import Multiselect from '@vueform/multiselect'
import SelectInput from '@/Shared/SelectInput'
import Checkbox from '@/Shared/Checkbox'
import axios from 'axios'

export default {
  components: {
    Head,
    Icon,
    Link,
    LoadingButton,
    TextInput,
    Multiselect,
    SelectInput,
    Checkbox,
  },
  layout: Layout,
  props: {
    customers: Object,
    onlineCustomers: Object,
    types: Array,
    errors: Object,
    onlineVoucherReasons: Object
  },
  data() {
    return {
      form: this.$inertia.form({
        voucher_reason: '',
        description: '',
        type: '',
        category: '',
        value: '',
        customer: null,
        online_customer: null,
        isOnlineCustomer: null,
      }),
      stepOne: true,
      stepTwo: false,
      selectedCustomer: null,
      isOnlineCustomer: false,
      customerType: 'normal',
      active: false,
      voucherReasons: null,
    }
  },
  computed: {
    user() {
      return this.$inertia.page.props.auth.user
    },
  },
  methods: {
    store() {
      this.form._method = 'post'
      this.form.customer = this.selectedCustomer
      this.$inertia.post('/vouchers', this.form, {
        onSuccess: () => {
          this.isOnlineCustomer = false
          this.customerType = 'normal'
          this.form.description = null
          this.form.voucher_reason = null
          this.form.id = null
          this.form.type = null
          this.form.category = null
          this.form.value = null
          this.form.customer = null
          this.form.online_customer = null
          this.form.isOnlineCustomer = false
          this.openCreateVoucher = false
        },
      })
    },
    showNext() {
      this.stepOne = false
      this.stepTwo = true
    },
    showBack() {
      this.stepOne = true
      this.stepTwo = false
    },
    onSelect(id, item) {
      this.selectedCustomer = item.value
      this.customerType = 'normal'
      axios.get(`/vouchers/reasons/${this.form.customer}/customer/${this.customerType}`).then(response => {
        this.voucherReasons = response.data
      })
    },
    onlineCustomer() {
      this.isOnlineCustomer = true
    },
  },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
.multiselect-option.is-selected.is-pointed {
  background: var(--ms-option-bg-selected-pointed, #fb923c);
  color: var(--ms-option-color-selected-pointed, #fff);
}

.multiselect-option.is-selected {
  background: var(--ms-option-bg-selected-pointed, #fb923c);
  color: var(--ms-option-color-selected-pointed, #fff);
}
</style>